import React from "react";
import { FieldRenderProps } from "react-final-form";
import { startOfDay } from "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import enLocale from "date-fns/locale/en-US";

import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
  KeyboardDateTimePicker,
} from "@material-ui/pickers";

import withFieldControl from "../FieldControl";

import { roundTime } from "utils/date";

type Props = {
  title?: string;
  required?: boolean;
  name: string;
  dateWithTimeMode?: boolean;
  minutesStep?: number;
};

class DateFieldControl extends React.Component<FieldRenderProps<any> & Props> {
  onChange = (date: Date | null) => {
    let event: any;
    if (date) {
      event = {
        target: { value: startOfDay(date) },
      };
    } else {
      event = {
        target: { value: "" },
      };
    }
    this.props.input.onChange(event);
  };

  onChangeDateTime = (date: Date | null) => {
    const { minutesStep } = this.props;

    if (date) {
      const roundedDate = minutesStep ? roundTime(date, minutesStep) : date;

      const event: any = {
        target: { value: roundedDate },
      };

      this.props.input.onChange(event);
    }
  };

  render() {
    const {
      title,
      required,
      input,
      meta,
      shifted,
      error,
      dateWithTimeMode,
      ...props
    } = this.props;

    return (
      <MuiPickersUtilsProvider
        utils={DateFnsUtils}
        locale={{
          ...enLocale,
          options: { ...enLocale.options, weekStartsOn: "1" },
        }}
      >
        {dateWithTimeMode ? (
          <KeyboardDateTimePicker
            value={input.value ? new Date(input.value) : null}
            onChange={this.onChangeDateTime}
            onAccept={this.onChangeDateTime}
            format="MM/dd/yyyy hh:mm a"
            label={title}
            helperText={((meta.touched || meta.dirty) && meta.error) || error}
            error={Boolean(
              ((meta.touched || meta.dirty) && meta.error) || error,
            )}
            required={required}
            {...props}
          />
        ) : (
          <KeyboardDatePicker
            value={input.value ? new Date(input.value) : null}
            onChange={this.onChange}
            onAccept={this.onChange}
            format="MM/dd/yyyy"
            label={title}
            helperText={((meta.touched || meta.dirty) && meta.error) || error}
            error={Boolean(
              ((meta.touched || meta.dirty) && meta.error) || error,
            )}
            required={required}
            {...props}
          />
        )}
      </MuiPickersUtilsProvider>
    );
  }
}

export default withFieldControl(DateFieldControl);
